/**
 * @description 品目模板数据字典
 */
import Dict from '@/utils/dict-utils'
import { purchaseTypeDict } from '@/dictionary/project/common'

// 模板状态
export const materialTemplateStatusDict = new Dict({
  REMOVED: { label: '已删除', value: -1, type: 'info' },
  DRAFT: { label: '草稿', value: 0, type: 'primary' },
  ENABLE: { label: '启用', value: 1, type: 'success' },
  DISABLED: { label: '禁用', value: 2, type: 'danger' }
})

// 模板归属
export const materialTemplateBelongDict = new Dict({
  INQUIRY: purchaseTypeDict.INQUIRY,
  NEGOTIATION_V2: purchaseTypeDict.NEGOTIATION_V2
})

// 定义类型
export const materialTemplateDefineTypeDict = new Dict({
  SYSTEM: { label: '系统创建', value: 1 },
  SPECIFY: { label: '采购人指定', value: 2 },
  RESPONSE: { label: '供应商响应', value: 3 }
})

// 供应商是否必填
export const materialTemplateKeySupplierRequireDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

// 供应商是否可见
export const materialTemplateKeySupplierVisibleDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

// 启用状态
export const materialTemplateKeyStatusDict = new Dict({
  CLOSED: { label: '关', value: 0 },
  OPENED: { label: '开', value: 1 }
})

// 字段类型
export const materialColumnTypeDict = new Dict({
  CUSTOM: { label: '自定义', value: 0 },
  CODE: { label: '编码', value: 1 },
  NAME: { label: '品目名称', value: 2 },
  NUM: { label: '数量', value: 3 },
  UNIT: { label: '计量单位', value: 4 },
  UNIT_PRICE: { label: '预算单价（元）', value: 5 },
  MODEL: { label: '参数型号', value: 6 },
  CONTROL_PRICE: { label: '控制价', value: 7 },
  RATE_OFFER: { label: '费率报价', value: 8 }
})
